var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.14 21.144a.465.465 0 01-.93 0 6.978 6.978 0 10-13.957 0 .465.465 0 01-.93 0 7.909 7.909 0 0115.818 0zm-7.908-8.84a4.652 4.652 0 110-9.304 4.652 4.652 0 010 9.305zm0-.93a3.722 3.722 0 100-7.444 3.722 3.722 0 000 7.444z"
  })));
};
export default __webpack_public_path__ + "static/media/profile.e7c6e2b6.svg";
export { SvgProfile as ReactComponent };